export function debounce(fn, delay) {
  let timer = null

  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), delay)
  }
}

export function isMobileDevice() {
  const userAgent = navigator.userAgent
  return /(android|ipad|iphone|ipod|mobile)/i.test(userAgent)
}
